import React, { useState } from 'react';
import './botUserCard.scss';
import { utilService } from '../../../../services';
import Call from '../../../../components/Shared/Call/call';
import TagList from '../customTagList/CustomTagList';
import defaultIcon from '../../../../assets/images/defaultProfilePic.png';
import copyIcon from '../../../../assets/images/copy-outline.svg';
import ChatbotCall from '../../../../components/Shared/Call/ChatbotCall';
import { IonIcon } from '@ionic/react';

interface BotUserCardProps {
  imageUrl: string;
  title: string;
  email?: string;
  isProfilePicSizeSmall?: boolean;
  onPressPhone?: () => void;
  onPressMessage?: () => void;
  onPressDocument?: () => void;
  guid?: string;
  specialisationNames?: string;
  teamNames?: string[];
}

const BotUserCard: React.FC<BotUserCardProps> = ({ imageUrl, title, email, isProfilePicSizeSmall = true, onPressPhone, onPressMessage, onPressDocument, guid, specialisationNames = '', teamNames = [] }) => {
  const specialisationArrayList = utilService.parseStringToArray(specialisationNames)
  const loggedInUserGuid = utilService.getLoggedUserGuid()
   const [copied, setCopied] = useState(false);

     const handleCopy = () => {
    if (!email) return;
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // hide after 2s
    });
  };


  const renderProfilePic = () => {
    const imageBaseUrl = utilService.getBaseUrl();
    const fullImageUrl = imageUrl && imageUrl.startsWith('profile_pic/') ? `${imageBaseUrl}/media/${imageUrl}` : null;
    const profilePicClass = `profile-pic ${isProfilePicSizeSmall ? 'small' : 'large'}`;


    return (
      <div className={profilePicClass}>
        {fullImageUrl ? (
          <img src={fullImageUrl} alt={title} onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = defaultIcon;
          }}
          />
        ) : (
          <img src={defaultIcon} alt="Default profile" />
        )}
      </div>
    );
  };
  return (
    <div className="bot-user-card">
      <div className="card-content">
        <div className="user-info">
          {renderProfilePic()}
          <div className="user-details">
            <div className="user-name" title={title}>{title}</div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {email && <div className="user-email" title={email}>{email}</div>}

        {email && (
<span style={{cursor: 'pointer'}}  onClick={()=>handleCopy()}>  <IonIcon
   
    slot="end"
    icon={copyIcon}
    color="medium" // Ionic predefined color (grey)
    style={{ cursor: 'pointer' }}
  /></span>
)}

        {copied && <span style={{ color: "grey" }}>Copied!</span>}
      </div>

            {Array.isArray(specialisationArrayList) && specialisationArrayList?.length > 0 && (
              <TagList
                items={specialisationArrayList}
                type="specialization"
                maxVisibleItems={1}
                size="small"
                showIcon={true}
                expandable={true}
              />
            )}

            <TagList
              items={teamNames}
              type="team"
              maxVisibleItems={1}
              size="small"
              showIcon={true}
              expandable={true}
            />


          </div>
        </div>

        <div className="action-buttons">
          {/* {onPressPhone && (
            <button className="action-button" onClick={onPressPhone}>
              <i className="fa fa-phone" aria-hidden="true"></i>
            </button>
          )} */}
          {guid && (
            <ChatbotCall
              selectedDoctorGuid={guid}
              disabled={loggedInUserGuid === guid ? true : false}
            />
          )}

          {onPressMessage && (
            <button className="action-button" onClick={onPressMessage}>
              <i className="fa fa-comment" aria-hidden="true"></i>
            </button>
          )}

          {onPressDocument && (
            <button className="action-button" onClick={onPressDocument}>
              <i className="fa fa-file-image-o" aria-hidden="true"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BotUserCard;